import { fork } from 'redux-saga/effects';
import { api } from 'redux/helpers';
import * as utils from 'utils/api/configuration/project';
import * as actions from './actions';


export default function* project() {
  yield fork(api(actions.GET_LIST, actions.getList, utils.getList));
  yield fork(api(actions.GET, actions.get, utils.get));
  yield fork(api(actions.GET_TEMPLATE, actions.getTemplate, utils.getTemplate));
  yield fork(api(actions.GET_ITEMS_CONFIGURATION, actions.getItemsConfiguration, utils.getItemsConfiguration));
  yield fork(api(actions.UPDATE_ITEMS_CONFIGURATION, actions.updateItemsConfiguration, utils.updateItemsConfiguration));
  yield fork(api(actions.GET_STATUSES, actions.getStatuses, utils.getStatuses));
  yield fork(api(actions.UPSERT_STATUS, actions.upsertStatus, utils.upsertStatus));
  yield fork(api(actions.GET_TAGS, actions.getTags, utils.getTags));
  yield fork(api(actions.UPSERT_TAGS, actions.upsertTags, utils.upsertTags));
  yield fork(api(actions.GET_BOARDS, actions.getBoards, utils.getBoards));
  yield fork(api(actions.UPSERT_BOARD, actions.upsertBoard, utils.upsertBoard));
  yield fork(api(actions.GET_CATEGORIES, actions.getCategories, utils.getCategories));
  yield fork(api(actions.UPSERT_CATEGORY, actions.upsertCategory, utils.upsertCategory));
  yield fork(api(actions.UPSERT, actions.upsert, utils.upsert));
  yield fork(api(actions.GET_TEMPLATES, actions.getTemplates, utils.getTemplates));
  yield fork(api(actions.UPSERT_TEMPLATE, actions.upsertTemplate, utils.upsertTemplate));
  yield fork(api(actions.GET_IS_PROJECT_NAME_UNIQUE, actions.getIsProjectNameUnique, utils.checkIsProjectNameUnique))
}



// WEBPACK FOOTER //
// ../redux/store/services/api/configuration/project/saga.js